import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';

const LanguagePicker = ({ className }) => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const languages = [
        { code: 'en', flag: 'gb', name: 'English', shortName: 'ENG' },
        { code: 'hy', flag: 'am', name: 'Հայերեն', shortName: 'ՀԱՅ' }
    ];

    const changeLanguage = (languageCode) => {
        i18n.changeLanguage(languageCode);
        setIsOpen(false);
        localStorage.setItem('selectedLanguage', languageCode);  // Save to localStorage
    };

    // Use an effect to set the language on initial load
    useEffect(() => {
        const savedLanguage = localStorage.getItem('selectedLanguage');
        if (
            savedLanguage &&
            languages.some(l => l.code === savedLanguage) &&
            i18n.language !== savedLanguage  // Check if current language is different
        ) {
            i18n.changeLanguage(savedLanguage);
        }
    }, [i18n, languages]);


    return (
        <div className={`relative inline-block text-left ml-auto mr-3 ${className}`}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                type="button"
                className="inline-flex items-center justify-center px-4 py-2 text-gray hover:text-orange-700 text-sm font-medium border border-gray-300 rounded-md shadow-sm hover:border-orange-400"
            >
                <span className={`fi fi-${languages.find(l => l.code === i18n.language).flag} mr-2`}></span>
                {languages.find(l => l.code === i18n.language).shortName}
                <span className="ml-2">
                    <FontAwesomeIcon icon={isOpen ? faCaretUp : faCaretDown} />
                </span>
            </button>
            {isOpen && (
                <div className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 border border-orange-400">
                    <div className="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                        {languages.map(({ code, flag, name }) => (
                            <button
                                key={code}
                                onClick={() => changeLanguage(code)}
                                className="text-left block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                                role="menuitem"
                            >
                                <span className={`fi fi-${flag} mr-2`}></span>
                                {name}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};


export default LanguagePicker;
